import React from "react";
import InputMask from "react-input-mask";
import InputPadraoProduto from "../../ui/Cliente/InputCliente";

export default function Endereco({ endereco, setEndereco }) {
  const handleChange = (campo, valor) => {
    setEndereco({ ...endereco, [campo]: valor });
  };

  const handleUfChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 2);
    handleChange("uf", value);
  };

  const handleNumeroChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    handleChange("numero", value);
  };

  return (
    <div className="mt-10 space-y-8">
      {/* 🔹 Título */}
      <div className="flex items-center gap-3 mb-4">
        <h2
          className="font-semibold"
          style={{
            fontFamily: "Comfortaa, cursive",
            fontSize: "16px",
            color: "#454545",
          }}
        >
          Endereço
        </h2>
        <div
          className="flex-1 h-[2px] rounded-full"
          style={{ backgroundColor: "#454545", opacity: 0.9 }}
        />
      </div>

      {/* 🔹 Linha 1 — CEP | Logradouro | Número */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {/* CEP menor */}
        <div className="md:col-span-2 relative w-full">
          <label
            className={`absolute left-2 transition-all duration-200 pointer-events-none
              ${
                endereco.cep
                  ? "-top-4 text-xs text-gray-600 font-normal"
                  : "top-2.5 text-sm text-[#00000080] font-medium"
              }`}
            style={{ fontFamily: "Comfortaa, cursive" }}
          >
            CEP
          </label>
          <InputMask
            mask="99999-999"
            maskChar={null}
            value={endereco.cep}
            onChange={(e) => handleChange("cep", e.target.value)}
          >
            {(inputProps) => (
              <input
                {...inputProps}
                className="w-full border-0 border-b px-2 py-2 text-sm
                  border-[#b5b5b5] hover:border-b-2 hover:border-[#b5b5b5]
                  focus:border-[#0088e3] focus:border-b-2
                  text-gray-800 placeholder-transparent focus:outline-none transition-all duration-200"
                style={{ fontFamily: "Comfortaa, cursive" }}
              />
            )}
          </InputMask>
        </div>

        {/* Logradouro maior */}
        <div className="md:col-span-8">
          <InputPadraoProduto
            value={endereco.logradouro}
            onChange={(e) => handleChange("logradouro", e.target.value)}
            placeholder="Logradouro"
          />
        </div>

        {/* Número */}
        <div className="md:col-span-2">
          <InputPadraoProduto
            value={endereco.numero}
            onChange={handleNumeroChange}
            placeholder="Número"
          />
        </div>
      </div>

      {/* 🔹 Linha 2 — Bairro | Cidade | UF */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        <div className="md:col-span-4">
          <InputPadraoProduto
            value={endereco.bairro}
            onChange={(e) => handleChange("bairro", e.target.value)}
            placeholder="Bairro"
          />
        </div>

        {/* Cidade um pouco maior */}
        <div className="md:col-span-6">
          <InputPadraoProduto
            value={endereco.cidade}
            onChange={(e) => handleChange("cidade", e.target.value)}
            placeholder="Cidade"
          />
        </div>

        {/* UF menor */}
        <div className="md:col-span-2">
          <InputPadraoProduto
            value={endereco.uf}
            onChange={handleUfChange}
            placeholder="UF"
            maxLength={2}
          />
        </div>
      </div>
    </div>
  );
}
